import { render, staticRenderFns } from "./PersonnelRecordEditTabAccounting.vue?vue&type=template&id=24f7bbb2"
import script from "./PersonnelRecordEditTabAccounting.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports